const jp = {
  'appManuals.downloadHelpText':
    'ダウンロードしたファイルは、インターネットブラウザまたはPDFリーダーソフトウェアで閲覧できます。',
  'appManuals.systemRequirements':
    'システム要件 (推奨): Intel® Core™ i3以上のCPU, 4 GB以上のメモリ, PDF保存用に100 MB以上の空き領域',
  'appManuals.medicalsoftware.helptext': '国によって医療ソフトウェアの有無が異なる場合があります。',
  '이미 등록된 라이선스가 있습니다.': '既に登録されたライセンスがあります。',
  '갱신 가능한 기존 라이선스를 찾을 수 없습니다.':
    '更新可能な既存のライセンスが見つかりません。',
  '발급 가능한 잔여 수량이 없습니다.': '発行可能な残数がありません。',
  // --- eIFU portal UI labels & language names (issue #16) ---
  'show all manuals': 'すべてのマニュアルを表示',
  'This site complies with the General Data Protection Regulation (EU 2016/679).': '本サイトは一般データ保護規則（EU 2016/679）に準拠しています。',
  'This site meets the requirements of the General Data Protection Regulation (EU 2016/679).': '本サイトは一般データ保護規則（EU 2016/679）の要件を満たしています。',
  'the content of this site is protected against unauthorized modification.': '本サイトのコンテンツは不正な変更から保護されています。',
  'Previous versions of the User Manual are available for viewing and downloading via search.': '以前のバージョンのユーザーマニュアルは検索により閲覧・ダウンロードできます。',
  'Checking the latest documents.': '最新のドキュメントを確認しています。',
  'There are no manuals to display.': '表示するマニュアルがありません。',
  'Manuals': 'マニュアル',
  'Product Name': '製品名',
  'Language': '言語',
  'Document Name': 'ドキュメント名',
  'Product': '製品',
  'Revision': 'リビジョン',
  'Document': 'ドキュメント',
  'Published': '公開日',
  'English': '英語',
  'Korean': '韓国語',
  'Japanese': '日本語',
  'German': 'ドイツ語',
  'Russian': 'ロシア語',
  'Chinese (Simplified)': '中国語（簡体字）',
  'Chinese (Traditional)': '中国語（繁体字）',
  'Country': '国',
  'eifuPortalIntro': 'RAY医療機器ソフトウェアの電子使用説明書（eIFU）を検索・ダウンロードできます。',
  "criticalNotice.badge": "重要なお知らせ",
  "criticalNotice.close": "閉じる",
};

export default jp;
